"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.borderRadiuses = exports.borderRadii = void 0;
/**
 * @deprecated use borderRadii object
 */
var borderRadiuses = exports.borderRadiuses = {
  /**
   * @deprecated use borderRadius05
   */
  borderRadiusSmall: '4px',
  /**
   * @deprecated use borderRadius10
   */
  borderRadiusMedium: '8px',
  /**
   * @deprecated use borderRadius20
   */
  borderRadiusLarge: '16px',
  /**
   * @deprecated use borderRadius30
   */
  borderRadiusXLarge: '24px'
};
var borderRadii = exports.borderRadii = {
  borderRadius05: '4px',
  borderRadius10: '8px',
  borderRadius15: '12px',
  borderRadius20: '16px',
  borderRadius30: '24px',
  borderRadius40: '32px'
};